<style src="./Layer.scss" lang="scss"></style>
<template src="./Layer.html"></template>

<script>
	import Teaser from '@/components/Teaser/Teaser';
	import { AdServiceWrapper } from '@/services/wrapper/adServiceWrapper';

	export default {
		props: {
			id: {
				type: String,
				required: true
			},
			fullsize: {
				type: Boolean,
				default: false
			},
			delay: {
				type: Number,
				default: 0
			},
			initialData: {
				type: Object,
				default: null
			}
		},
		data () {
			return {
				open: false,
				hidePermanently: false,
				brand: process.env.VUE_APP_BRAND
			};
		},
		watch: {
			open: function () {
				this.open ? this.openLayer() : this.closeLayer();
			},
			hidePermanently: function () {
				this.open = false;

				// if (this.$router.currentRoute === '/') {
				localStorage.setItem('info-layer-home-inactive', '1');
				// } else {
				//     localStorage.setItem('info-layer-logout-inactive', '1');
				// }
			}
		},
		methods: {
			openLayer: function () {
				document.body.setAttribute('data-show-layer', this.id);
				this.checkOverflow();
				window.addEventListener('resize', this.checkOverflow);
				document.addEventListener('click', this.checkFocus);
				let event = new CustomEvent('layerOpened', {
					bubbles: true,
					cancelable: true,
					id: this.id,
					detail: { source: 'Layer.vue' }
				});
				document.body.dispatchEvent(event);
			},
			closeLayer: function () {
				document.body.removeAttribute('data-show-layer');
				window.removeEventListener('resize', this.checkOverflow);
				document.removeEventListener('click', this.checkFocus);
				let event = new CustomEvent('layerClosed', {
					bubbles: true,
					cancelable: true,
					id: this.id,
					detail: { source: 'Layer.vue' }
				});
				document.body.dispatchEvent(event);
			},
			// Layer scrollable for large content in small viewport.
			checkOverflow: function () {
				if (this.fullsize === 'true') {
					return;
				}
				// Tip: 0px height/width without setTimeout
				let content = this.$el.querySelector('[data-layer-content]');
				setTimeout(() => {
					window.innerHeight < content.scrollHeight ? (content.style.height = '100%') : (content.style.height = null);
				}, 100);
			},
			checkFocus: function (event) {
				this.$el.querySelector('[data-layer-content]').contains(event.target) ? (this.open = true) : (this.open = false);
			}
		},
		mounted () {
			if (localStorage.getItem('info-layer-home-inactive') === '1' || localStorage.getItem('info-layer-logout-inactive') === '1') {
				return;
			}

			setTimeout(() => {
				this.open = true;
				document.addEventListener('layerOpened', () => {
					document.querySelector('[data-service-slot]').innerHTML = '';
					setTimeout(() => {
						AdServiceWrapper.makeAd('rectangle_layer');
					}, 100);
				});
			}, this.delay);
		},
		components: {
			'hp-teaser': Teaser
		}
	};
</script>
